import React from "react";

import { Spacer } from "shared/layout";
import { useStagePageContext, useVenuePageContext } from "Venues/contexts";
import { StageBlocks, InfoCard } from "./containers";

const StagePage: React.FC = () => {
  const { venueId, openDeleteStageModal } = useVenuePageContext();
  const { stage, stageId, userStagePermissions } = useStagePageContext();

  if (stage === null || !stageId) return null;
  return (
    <Spacer size="m">
      <InfoCard
        stage={stage}
        venueId={venueId}
        userPermissions={userStagePermissions}
        openDeleteStageModal={openDeleteStageModal}
      />
      <StageBlocks />
    </Spacer>
  );
};

export default StagePage;
